import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { wrenchIcon } from '../../../../icons';

@Component({
    selector: 'app-book-workshop-success',
    template: `
        <div class="book-workshop-success__icon">${wrenchIcon}</div>
        <app-rich-text class="book-workshop-success-rich-text" [html]="richText"></app-rich-text>
        <app-button
            buttonClass="button--primary book-workshop-success-button"
            (click)="closed.emit()"
            [title]="'book_workshop.go_to_front_page' | translate"
        >
        </app-button>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookWorkshopSuccessComponent implements OnInit {
    @Input() clientEmail?: string;
    @Input() richText?: string | null;
    @Output() closed = new EventEmitter();

    ngOnInit(): void {
        this.injectEmailInRichText();
    }

    injectEmailInRichText() {
        if (this.clientEmail && this.richText) {
            const emailMarkup = `<span class="theme-text"><a href="mailto:${this.clientEmail}" title="${this.clientEmail}">${this.clientEmail}</a></span>`;

            this.richText = this.richText?.replace('{{email}}', emailMarkup);
        }
    }
}
